<template>
  <img v-if="showImage" :src="avatarSrc" :style="sizeStyle" class="object-cover flex-shrink-0"
  @load="$emit('load')" @error="handleImageError">
  <div v-else :style="sizeStyle" class="flex items-center justify-center flex-shrink-0"
  :class="dark ? 'bg-neutral-alpha-300' : 'bg-neutral-100'">
    <BaseText type="label" :size="initialsSize" class="uppercase"
    :class="dark ? 'text-neutral-alpha-600' : 'text-text-normal'">
      {{ initials }}
    </BaseText>
  </div>
</template>

<script>
// Renders a brand's avatar, falling back to the brand's initials when there is no avatar
// or the avatar fails to load. Border radius and spacing are set by the parent via `class`.
export default {
  name: 'BrandAvatar',
  props: {
    avatarSrc: {
      type: String,
      default: ''
    },
    brandName: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 32
    },
    height: {
      type: Number,
      default: 32
    },
    // Defaults to a size scaled to the avatar width
    fontSize: {
      type: String,
      default: null
    },
    // Use placeholder colors suited to dark surfaces
    dark: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      imageFailed: false
    }
  },
  computed: {
    showImage () {
      return !!this.avatarSrc?.length && !this.imageFailed
    },
    sizeStyle () {
      return { width: `${this.width}px`, height: `${this.height}px` }
    },
    initialsSize () {
      if (this.fontSize) return this.fontSize
      if (this.width <= 24) return 'xs'
      if (this.width <= 32) return 'sm'
      return 'md'
    },
    initials () {
      const name = this.brandName?.trim()
      if (!name) return '?'
      return name.split(/\s+/).map(word => word[0]).join('').slice(0, 2)
    }
  },
  watch: {
    avatarSrc () {
      this.imageFailed = false
    }
  },
  methods: {
    handleImageError () {
      this.imageFailed = true
      this.$emit('error')
    }
  }
}
</script>
